<template>
  <div id="main">
    <PageSlider />
  </div>
</template>

<script>
import PageSlider from "@/components/PageSlider";

export default {
  name: "Main",
  components: { PageSlider }
};
</script>

<style lang="scss" scoped>
#main {
  height: 100%;
}
</style>
